export function AdminsysDashboardPage() {
  return (
    <div>
      <h1>Tableau de bord du AdminSys</h1>
      <h3>Contenu à venir</h3>
    </div>
  )
}